var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElearning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300px",
    height: "80px",
    viewBox: "0 0 300 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Slice") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#006A92",
    x: 0,
    y: 0,
    width: 300,
    height: 80
  }), /*#__PURE__*/React.createElement("line", {
    x1: 304,
    y1: 66,
    x2: 270,
    y2: 80,
    id: "Line",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Square-E-Learning",
    transform: "translate(225.000000, 4.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Laag_1",
    fill: "#006A92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.83,65 L65,58.39 L65,65 L46.83,65 Z M65,0 L0,0 L0,65 L42.44,65 L65,56.79 L65,0 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Laag_2",
    transform: "translate(7.000000, 15.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.69,0 L2.31,0 C1.03649798,0.00547750391 0.00547750391,1.03649798 1.77635684e-15,2.31 L1.77635684e-15,28.69 C0.00547750391,29.963502 1.03649798,30.9945225 2.31,31 L21,31 L19.16,35.32 L13,35.32 C12.7238576,35.32 12.5,35.5438576 12.5,35.82 L12.5,38.32 L7.32,38.32 C7.04385763,38.32 6.82,38.5438576 6.82,38.82 C6.82,39.0961424 7.04385763,39.32 7.32,39.32 L43.69,39.32 C43.9639085,39.3146799 44.1846799,39.0939085 44.19,38.82 C44.19,38.5438576 43.9661424,38.32 43.69,38.32 L38.5,38.32 L38.5,35.82 C38.5,35.5438576 38.2761424,35.32 38,35.32 L31.83,35.32 L30,31 L48.7,31 C49.9695951,30.9890664 50.9945745,29.9596306 51,28.69 L51,2.31 C50.9945225,1.03649798 49.963502,0.00547750391 48.69,0 Z M2.31,1 L48.69,1 C49.413493,1 50,1.58650698 50,2.31 L50,26.4 L1,26.4 L1,2.31 C1,1.58650698 1.58650698,1 2.31,1 Z M37.5,38.32 L13.5,38.32 L13.5,36.32 L37.5,36.32 L37.5,38.32 Z M30.74,35.32 L20.26,35.32 L22.1,31 L28.9,31 L30.74,35.32 Z M48.69,30 L2.31,30 C1.58650698,30 1,29.413493 1,28.69 L1,27.4 L50,27.4 L50,28.69 C50,29.413493 49.413493,30 48.69,30 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,10.09 L16,12.26 C16,12.26 16,12.26 16,12.26 L16,20.78 C16,22.1607119 17.1192881,23.28 18.5,23.28 L32.5,23.28 C33.8807119,23.28 35,22.1607119 35,20.78 L35,12.38 C35,12.38 35,12.38 35,12.32 L40.22,10.44 L40.22,15.33 C38.9625184,15.5866824 38.1036652,16.7538494 38.2326596,18.0307621 C38.361654,19.3076749 39.4365882,20.2794897 40.72,20.2794897 C42.0034118,20.2794897 43.078346,19.3076749 43.2073404,18.0307621 C43.3363348,16.7538494 42.4774816,15.5866824 41.22,15.33 L41.22,9.74 L41.22,9.74 C41.22,9.74 41.22,9.74 41.22,9.74 C41.2133466,9.66550229 41.1893759,9.59359022 41.15,9.53 L41.1,9.44 C41.0559905,9.39133949 41.001193,9.35366621 40.94,9.33 L40.89,9.33 L25.45,3.71 C25.3401462,3.67028362 25.2198538,3.67028362 25.11,3.71 L10,9.15 C9.80225776,9.22177085 9.67058722,9.40963592 9.67058722,9.62 C9.67058722,9.83036408 9.80225776,10.0182292 10,10.09 Z M34,20.83 C34,21.6584271 33.3284271,22.33 32.5,22.33 L18.5,22.33 C17.6715729,22.33 17,21.6584271 17,20.83 L17,12.62 L25.41,15.62 C25.4661956,15.6303334 25.5238044,15.6303334 25.58,15.62 L25.75,15.62 L34,12.62 L34,20.83 Z M42.21,17.83 C42.21,18.6584271 41.5384271,19.33 40.71,19.33 C39.8815729,19.33 39.21,18.6584271 39.21,17.83 C39.21,17.0015729 39.8815729,16.33 40.71,16.33 C41.5171937,16.3347088 42.1779393,16.9734295 42.21,17.78 L42.21,17.83 Z M25.28,4.71 L39.23,9.71 L25.58,14.65 L11.63,9.65 L25.28,4.71 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElearning);
export default __webpack_public_path__ + "static/media/elearning.6371c3ff6bd6b0887c5cb0b5cb031dc7.svg";
export { ForwardRef as ReactComponent };